"use client"

import { CentraLanguageCode } from "@/data/supported-languages"
import { removeUserLocaleClient } from "@/lib/cookie/site-cookie/cookieActions.client"
import { isClient } from "@/lib/env-utils/env-utils"
import { t } from "@/translations"

export default function ChangeCountryLink({
    langCode
}: {
    langCode: CentraLanguageCode
}) {
    const siteUrl = process.env.NEXT_PUBLIC_SITEMAP_DOMAIN || "https://localhost:3000"
    const handleClick = () => {
        removeUserLocaleClient()
    }

    return (
        <a
            href={siteUrl}
            className="py-6 font-trimRegular"
            onClick={isClient ? handleClick : undefined}
        >
            {t(langCode, "footer.select_location")}
        </a>
    )
}
